var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attr-category"},[_c('CompButton',{attrs:{"placeholder":"选择标签","format":"{0}个标签","value":_vm.value.length,"view-btn":false},on:{"click":_vm.onAddLabel,"remove":_vm.onRemoveLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }